export const LogoMark = ({ className = "h-11 w-11" }) => (
  <img
    src="/assets/logo.jpeg"
    alt="D & N Constructions logo"
    className={`${className} shrink-0 rounded-xl object-cover ring-1 ring-gold/30`}
  />
);

export const Logo = ({ light = true }) => (
  <span className="flex items-center gap-3" data-testid="brand-logo">
    <LogoMark />
    <span className="leading-none">
      <span className={`block font-display text-lg font-semibold tracking-wide ${light ? "text-offwhite" : "text-charcoal"}`}>
        D <span className="text-gold">&amp;</span> N
      </span>
      <span className={`block text-[10px] font-bold uppercase tracking-[0.3em] ${light ? "text-white/60" : "text-charcoal/60"}`}>
        Constructions
      </span>
    </span>
  </span>
);
